"use client"

import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslations } from 'next-intl';

const FAQItem = ({ question, answer, isOpen, onClick, isActive }) => {
  return (
    <div className="relative">
      <div className={`absolute -inset-1 rounded-xl transition-opacity duration-300 ${isActive ? 'opacity-100' : 'opacity-0'}`}>
        <div 
          className="w-full h-full mx-auto opacity-30 blur-lg filter rounded-xl"
          style={{
            background: "linear-gradient(90deg, #8735D9 0%, #44ff9a 100%)"
          }}
        />
      </div>
      <div className="relative overflow-hidden bg-gray-900 border border-gray-800 rounded-xl">
        <h3>
          <button
            onClick={onClick}
            className="flex items-center justify-between w-full px-6 py-5 text-xl font-bold text-left text-white sm:p-8 font-pj"
          >
            <span>{question}</span>
            {isOpen ? (
              <ChevronUp className="w-6 h-6 text-neongreen" />
            ) : (
              <ChevronDown className="w-6 h-6 text-neongreen" />
            )}
          </button>
        </h3>
        <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
          <div className="px-6 pb-6 sm:px-8 sm:pb-8 text-gray-300">
            {answer}
          </div>
        </div>
      </div>
    </div>
  );
};

const FAQ = ({ translationKey }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const t = useTranslations(translationKey);

  // 获取 FAQ 数据的长度
  const faqDataLength = t.raw('faqData').length;

  return (
    <section className="py-12 bg-black sm:py-16 lg:py-20">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white sm:text-4xl xl:text-5xl font-pj">
            {t('title')}
          </h2>
          <p className="max-w-lg mx-auto mt-6 text-base text-gray-400 font-pj">
            {t('description')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto mt-8 sm:mt-14">
          <div className="space-y-4">
            {[...Array(faqDataLength)].map((_, index) => (
              <FAQItem
                key={index}
                question={t(`faqData.${index}.question`)}
                answer={t(`faqData.${index}.answer`)}
                isOpen={activeIndex === index}
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                isActive={activeIndex === index}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;